import React from 'react'
import {Link} from "react-router-dom";
import ClinicDashboard from "./pages/ClinicDashboard";
import "./clinics.css";

const Clinics = () => {
    return (
        <>
            <div className="container container-xxl">
                <div className="pagetitle d-flex justify-content-between">
                    <h1><i className="bi bi-hospital"></i> Clinics</h1>
                    <div>

                        <Link to="/clinics/new" className="btn btn-sm btn-outline-primary"><i className="bi bi-plus"></i>
                            Start Onboarding
                        </Link>
                    </div>
                </div>

                <ClinicDashboard/>
            </div>


        </>
    );
}

export default Clinics;